import initMap from './dealer-locator';

export default function(mapElement, formElement, dealerFilter) {
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    }
    const map = mapElement;
    // const youtubeVideo = document.getElementById('homepage-embed-youtube');
    let initializedMap = false;
    // let initializedVideo = false;
    // Watch for when the map is in viewport
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // If the map is in the viewport, then initialize it and stop observing
            if (entry.isIntersecting && entry.target == map && !initializedMap) {
                initMap(52.372823, -2.985798, 7, 52.509022, -1.051585, 6.5, map, formElement, dealerFilter);
                initializedMap = true;
                observer.unobserve(map);
            }
            // if (entry.isIntersecting && entry.target == youtubeVideo && !initializedVideo) {
            //     youtubeVideo.innerHTML = `<iframe width="640" height="360" src="https://www.youtube.com/embed/qcFGNQr9UH8?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            //     initializedVideo = true;
            //     observer.unobserve(youtubeVideo);
            // }
        })
    }, options);

    observer.observe(map);
    // observer.observe(youtubeVideo);
}


// WEBPACK FOOTER //
// ./resources/assets/js/homepages/modules/lazy-load.js